import React from "react"
import { StandardModal } from "uikit"

class CountdownTimer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      time: props.timeout
    }
    this.timer = 0
  }

  componentDidMount() {
    this.startTimer()
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  startTimer() {
    if (!this.timer) {
      this.timer = setInterval(this.updateTime, 1000)
    }
  }

  updateTime = () => {
    const time = this.state.time - 1000
    if (time <= 0) {
      clearInterval(this.timer)
      this.props.onCountdownFinished()
      return
    }
    this.setState({ time })
  }

  render() {
    const seconds = Math.round(this.state.time / 1000)
    const rest = seconds % 60
    return (
      <span>{`${Math.floor(seconds / 60)}:${
        rest < 10 ? "0" : ""
      }${rest}`}</span>
    )
  }
}

const RenewSessionModal = ({ onYes, onNo, autoSignoutTimeout }) => (
  <StandardModal defaultOpen={true} closeOnDimmerClick={false}>
    <StandardModal.Header header="Your Session Will Expire Soon" />
    <StandardModal.Content>
      <div>
        Due to inactivity, your session will expire soon. Do you want to stay
        signed in?
      </div>
      <p style={{ fontSize: ".8em", fontWeight: "600" }}>
        You will be automatically signed off in{" "}
        <CountdownTimer
          timeout={autoSignoutTimeout}
          onCountdownFinished={() => {
            onNo()
          }}
        />
      </p>
    </StandardModal.Content>
    <StandardModal.Actions
      submitLabel="Yes"
      cancelLabel="No"
      onSubmit={() => onYes()}
      onCancel={() => onNo()}
      loading={false}
    />
  </StandardModal>
)

export default RenewSessionModal
